export enum Platform {
  ChessCom,
  Lichess,
  None,
}
